import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import iconMonitora from "../../assets/img/icon_monitora.png";
import iconRag from "../../assets/img/icon_rag.png";
import styles from "./styles.module.scss";

export const CardMenu = () => {
  const [isTabela, setIsTabela] = useState(false);
  const [expandedCards, setExpandedCards] = useState([]);
  const dispatch = useDispatch();

  function contentText(modulo) {
    if (modulo === "MON") {
      return (
        <>
          <p>
            O monitoramento consiste em acompanhar a execução do Plano de Trabalho Anual - PTA ao longo do ano e tem por
            objetivos:
          </p>
          <ul>
            <li>Acompanhar a execução das ações e o alcance das metas planejadas pelos órgãos;</li>
            <li>Identificar, tempestivamente, ocorrências que impactem a execução das ações;</li>
            <li>Subsidiar a tomada de decisão acerca da atuação governamental;</li>
            <li>Subsidiar a prestação de contas e a avaliação dos programas e ações;</li>
            <li>
              Concentrar informações que contribuam para o aprimoramento do planejamento nos processos de revisão.
            </li>
          </ul>
        </>
      );
    } else if (modulo === "RAG") {
      return (
        <>
          <p>
            O Relatório Anual de Gestão - RAG é uma avaliação do desempenho dos programas e das ações desenhados no
            Plano Plurianual - PPA (planejamento de médio prazo) e operacionalizados anualmente através das Leis
            Orçamentárias Anuais - LOA's (planejamento de curto prazo) e seus respectivos Planos de Trabalho Anual -
            PTA's.
          </p>
          <p>
            A avaliação anual é parte fundamental do modelo de gestão do PPA e tem como objetivo contribuir para o
            alcance dos resultados inicialmente previstos nos programas, por meio do aperfeiçoamento contínuo da gestão
            desses programas e da alocação de recursos no orçamento do Estado, de modo a aprimorar a qualidade do gasto
            público.
          </p>
        </>
      );
    }
  }

  const [menu] = useState([
    {
      title: "MONITORAMENTO",
      subTitle: "",
      icon: iconMonitora,
      content: contentText("MON"),
      imageUrl: "./images/01.png",
      pathUrl: "/monlancamentos",
    },
    {
      title: "RELATÓRIO ANUAL DE GESTÃO-RAG",
      icon: iconRag,
      content: contentText("RAG"),
      subTitle: "",
      imageUrl: "./images/01.png",
      pathUrl: "/raglancamentos",
    },
  ]);

  const setMenu = (title) => {
    if (title === "MONITORAMENTO") {
      dispatch({ type: "setMenu", value: 1 });
    }
    if (title === "RELATÓRIO ANUAL DE GESTÃO-RAG") {
      dispatch({ type: "setMenu", value: 2 });
    }
  };

  const toggleExpand = (index) => {
    const newExpandedCards = [...expandedCards];
    newExpandedCards[index] = !newExpandedCards[index];
    setExpandedCards(newExpandedCards);
  };

  return (
    <div>
      <h2 className={styles.title}>Clique no módulo que deseja acessar</h2>
      <div className={styles.container}>
        {!isTabela &&
          menu.map((item, key) => {
            return (
              <div style={{ height: "1000px" }}>
                <Link
                  key={key}
                  to={item.pathUrl}
                  onClick={() => {
                    item.title === "Tabelas" ? setIsTabela(true) : setIsTabela(false);
                    setMenu(item.title);
                  }}
                >
                  <Card
                    className={styles.card_container}
                    title={item.title}
                    subTitle={item.subTitle}
                    style={{ backgocolor: "#FFFFFF" }}
                  >
                    <div className={styles.image_icon}>
                      <img src={item.icon} alt={item.imgDesc} style={{ fontSize: "2em", color: "#FFFFFF" }} />
                      <i className={item.icon} style={{ fontSize: "2em", color: "#FFFFFF" }}></i>
                    </div>
                  </Card>
                </Link>
                <button className={styles.buttoncard} onClick={() => toggleExpand(key)}>
                  Saiba mais
                  {expandedCards[key] ? (
                    <i className="pi pi-chevron-down" style={{ marginLeft: "1rem" }}></i>
                  ) : (
                    <i className="pi pi-chevron-right" style={{ marginLeft: "1rem" }}></i>
                  )}
                </button>
                <div
                  className={styles.text}
                  style={{ maxHeight: expandedCards[key] ? "none" : "0px", overflow: "hidden", width: "420px" }}
                >
                  {expandedCards.length > 0 && item.content}
                  {/* //   {item.content} */}
                </div>
              </div>
            );
          })}
        {isTabela && (
          <>
            <Button
              icon="pi pi-arrow-left"
              label=" Voltar"
              className=" p-button-text"
              onClick={() => setIsTabela(false)}
              style={{ fontWeight: 500 }}
            />
            <Link to="/manterAmparoLegal">
              <Card className={styles.card_container} title="Amparo Legal" subTitle="Ir para o Amparo Legal" />
            </Link>

            <Link to="/materTipoCertidao">
              <Card
                className={styles.card_container}
                title="Tipos de Certidão"
                subTitle="Ir para o Tipos de Certidão"
              />
            </Link>
          </>
        )}
      </div>
    </div>
  );
};
